import { render, staticRenderFns } from "./BasicFieldInfoForm.vue?vue&type=template&id=4823b842&scoped=true&lang=html&"
import script from "./BasicFieldInfoForm.vue?vue&type=script&lang=js&"
export * from "./BasicFieldInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicFieldInfoForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BasicFieldInfoForm.vue?vue&type=style&index=1&id=4823b842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823b842",
  null
  
)

export default component.exports